import React, { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { Panel } from "@/components/common";
import { Input } from "@/components/ui/input";
import { Prohibit } from "@phosphor-icons/react";
import { toast } from "sonner";
import { Transcript } from "@/components/telecalling/CampaignDetail";

export function CallLog() {
  const [calls, setCalls] = useState([]);
  const [dnc, setDnc] = useState([]);
  const [phone, setPhone] = useState("");
  const [open, setOpen] = useState(null);
  const load = () => { api.get("/telecalling/calls").then(({ data }) => setCalls(data)).catch(() => {}); api.get("/telecalling/dnc").then(({ data }) => setDnc(data)).catch(() => {}); };
  useEffect(() => { load(); const t = setInterval(load, 10000); return () => clearInterval(t); }, []);
  const add = async () => {
    try { await api.post("/telecalling/dnc", { phone }); setPhone(""); toast.success("Added to Do-Not-Call"); load(); }
    catch (e) { toast.error(apiError(e.response?.data?.detail)); }
  };
  return (
    <div className="grid lg:grid-cols-[1fr_320px] gap-6">
      <Panel className="divide-y divide-slate-100" data-testid="tc-calls">
        {!calls.length && <p className="p-8 text-sm text-slate-400 text-center">No calls yet.</p>}
        {calls.map((c) => (
          <div key={c.call_sid || c.created_at} className="p-4" data-testid={`tc-call-${c.call_sid}`}>
            <div className="flex flex-wrap items-center gap-3">
              <div className="flex-1"><p className="font-semibold text-slate-900">{c.company || c.to}</p><p className="text-xs text-slate-500 font-mono">{c.to} · {new Date(c.created_at).toLocaleString()}{c.duration ? ` · ${c.duration}s` : ""}</p></div>
              <span className="text-xs capitalize text-slate-600">{c.status}</span>
              {c.outcome && <span className="text-[11px] font-semibold px-2 py-0.5 rounded-full bg-slate-900 text-white">{c.outcome}</span>}
              {c.transcript?.length > 0 && <button onClick={() => setOpen(open === c.call_sid ? null : c.call_sid)} className="text-xs text-blue-600">Transcript</button>}
            </div>
            {c.summary && <p className="text-xs text-slate-600 mt-1">{c.summary}</p>}
            {open === c.call_sid && <div className="mt-2 rounded-lg bg-slate-50 p-3"><Transcript rows={c.transcript} /></div>}
          </div>
        ))}
      </Panel>
      <Panel className="p-5" data-testid="tc-dnc">
        <p className="font-heading font-bold text-slate-900 inline-flex items-center gap-2"><Prohibit size={18} className="text-red-500" />Do-Not-Call list</p>
        <div className="flex gap-2 mt-3"><Input value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="Phone number" className="bg-white border-slate-300" data-testid="tc-dnc-input" /><button onClick={add} className="h-10 px-3 rounded-lg bg-red-600 text-white text-sm font-semibold" data-testid="tc-dnc-add">Add</button></div>
        <div className="mt-3 space-y-1 max-h-80 overflow-y-auto">{dnc.map((d) => <p key={d.phone} className="text-xs font-mono text-slate-600">{d.phone} <span className="text-slate-400 font-sans">· {d.source}</span></p>)}</div>
      </Panel>
    </div>
  );
}
